import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Validators, FormBuilder, FormGroupDirective } from '@angular/forms';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { ValidatingEnroleeMessage } from 'src/app/utility/services/message/custom-messages';
import { AppContentMessage } from '../../model/appContentMessage';
import { NavigateService } from 'src/app/utility/services/navigate/navigate.service';
import { StorageService } from 'src/app/utility/services/storage/storage.service';
import { AuthService } from 'src/app/feature-module/auth/services/auth.service';
import { EbDashboardAuthService } from 'src/app/feature-module/reporting/services/eb-dashboard-auth/eb-dashboard-auth.service';
import { TYPE } from 'src/app/utility/constants/Constant';
import { LoginType } from 'src/app/utility/enum/global-enum';

@Component({
  selector: 'app-eb-dashboard-login',
  templateUrl: './eb-dashboard-login.component.html',
  styleUrls: ['./eb-dashboard-login.component.scss']
})
export class EbDashboardLoginComponent implements OnInit {

  birthYearRegularExpression = "^(19|20)[0-9]{2,2}$";
  otpFlag = false;
  timeLeft = 120;
  browserId: string;
  subscribeTimer: any;
  message: any;
  isOtpGenerate = false;
  enrolId: number;
  groupPolicyNo: string;
  groupPolicyName: string;
  certificateNo: string;
  birthYear: number;
  customMessage = new ValidatingEnroleeMessage();
  otpFromDirective: FormGroupDirective;
  loginFormDirective: FormGroupDirective;
  productList: any[] = [];
  relationList: any = [];
  dependentProducts: any = [];
  insuredName: string;
  requestToken: string;
  recaptchaToken: string;

  @Input() set isParentTabSelectionChange(value) {
    if (value) {
      this.clearTimer();
      this.resetFormSettings();
      this.resetIsParentTabSelectionChangeValue.emit();
    }
  }
  @Output() resetIsParentTabSelectionChangeValue = new EventEmitter<any>();
  @Output() onValidOTP = new EventEmitter<any>();

  loginForm = this.fb.group({
    groupPolicyNo: [null, [Validators.required]],
    certificateNo: [null, [Validators.required]],
    birthYear: [null, [Validators.required, Validators.pattern(this.birthYearRegularExpression)]],
    recaptcha: [null, [Validators.required]],
  });

  otpForm = this.fb.group({
    otpNumber: [null, [Validators.required]],
    enrolId: [0]
  });
  
  constructor(
    private fb: FormBuilder,
    private ebDashboardAuthService: EbDashboardAuthService,
    private messageService: MessageService,
    private navigate: NavigateService,
    private storage: StorageService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.timeLeft = this.customMessage.otpLeftTime;
  }

  genarateOTP(formDirective: FormGroupDirective) {
    this.loginFormDirective = formDirective;
    this.otpFlag = false;
    const entity = this.loginForm.value;

    this.ebDashboardAuthService
      .generateOtp(entity.groupPolicyNo, entity.birthYear, entity.certificateNo, entity.recaptcha)
      .subscribe(
        res => {
          if (res.status != AppContentMessage.RESPONSE_STATUS_SUCCESS) {
            this.messageService.show(res.msg, "error");
            return;
          }
          this.otpFlag = true;
          this.isOtpGenerate = !this.isOtpGenerate;
          this.message = res.msg;
          this.enrolId = res.data.res.id;
          this.browserId = res.data.res.browserId;
          this.requestToken = res.data.res.requestToken;
          this.groupPolicyNo = entity.groupPolicyNo;
          this.certificateNo = entity.certificateNo;
          this.birthYear = entity.birthYear;
          sessionStorage.setItem('requestToken', res.data.res.requestToken);
          this.startTimer();

          this.otpForm.patchValue({
            enrolId: res.data.res.id
          });
        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      );
  }

  startTimer() {
    this.subscribeTimer = setInterval(() => {
      this.timeLeft--;
      if (this.timeLeft == 0) {
        this.clearTimer();
        this.otpFlag = false;
        this.timeLeft = this.customMessage.otpLeftTime;
        this.isOtpGenerate = false;
        this.messageService.show(this.customMessage.otpTimeExpire, "error");
        this.otpForm.reset();
        this.loginForm.reset({ recaptcha: null });
        grecaptcha.reset();
      }
    }, 1000);
  }

  clearTimer() {
    this.timeLeft = this.customMessage.otpLeftTime;
    clearInterval(this.subscribeTimer);
  }

  verifyOTP(
    loginFormDirective: FormGroupDirective,
    otpFormDirective: FormGroupDirective
  ) {
    this.otpFromDirective = otpFormDirective;
    this.loginFormDirective = loginFormDirective;
    const entity = this.otpForm.value;
    this.ebDashboardAuthService
      .otpValidation(entity.otpNumber, entity.enrolId)
      .subscribe(
        res => {
          this.storage.reset();
          Object.keys(res.data).forEach(x => {
            this.storage.setItem(x, res.data[x]);
          });
          
          this.authService.setAuthenitication(true);
          this.storage.setItem(TYPE, LoginType.Enrol)

          this.clearTimer();
          this.resetFormSettings();
          this.navigate.toEbDashboard();
        },
        error => {
          if (AppContentMessage.OTP_VALIDATION_Try_Limit_Exceeded == error.error.message) {
            this.clearTimer();
            this.resetFormSettings();
          }
          this.messageService.show(error.error.message, "error");
        }
      );
  }

  resetFormSettings() {
    if (this.loginFormDirective != null) {
      this.loginFormDirective.resetForm();
    }
    if (this.otpFromDirective != null) {
      this.otpFromDirective.resetForm();
    }
    this.loginForm.reset({ recaptcha: null });
    this.otpForm.reset();
    this.otpFlag = false;
    this.timeLeft = this.customMessage.otpLeftTime;
    this.isOtpGenerate = false;
    grecaptcha.reset();
  }

  resolved = (captchaKey: string) => {
    this.loginForm.patchValue({ recaptcha: captchaKey });
  }


}
